import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { HierarchyTagStore } from "@/types/HierarchyTag";
import {
  Report,
  ReportProcessFilter,
  ReportDateFilter,
  ReportUnitValueTypeFilter,
  ReportFilter,
} from "@/types/Report";
import DateFilter from "./DateFilter.vue";
import ProcessFilter from "./ProcessFilter.vue";
import UnitValueTypeFilter from "./UnitValueTypeFilter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomFilters',
  props: {
    report: {},
    hierarchyTags: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const processFilter = ref<typeof ProcessFilter | null>(null);
const dateFilter = ref<typeof DateFilter | null>(null);
const unitValueTypeFilters = ref<typeof UnitValueTypeFilter | null>(null);

const getFilters = (): ReportFilter[] =>
  [
    processFilter.value?.getFilters?.(),
    dateFilter.value?.getFilters?.(),
    unitValueTypeFilters.value?.getFilters?.(),
  ].filter(Boolean);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.report?.filters.some((f) => f.type === 'processes'))
      ? (_openBlock(), _createBlock(ProcessFilter, {
          key: 0,
          hierarchyTags: _ctx.hierarchyTags,
          ref_key: "processFilter",
          ref: processFilter,
          onRefetch: _cache[0] || (_cache[0] = ($event: any) => (emit('update', getFilters()))),
          selected: _ctx.report?.filters.find((f) => f.type === 'processes')?.value as ReportProcessFilter['value']
        }, null, 8, ["hierarchyTags", "selected"]))
      : _createCommentVNode("", true),
    (_ctx.report?.filters.some((f) => f.type === 'daterange'))
      ? (_openBlock(), _createBlock(DateFilter, {
          key: 1,
          ref_key: "dateFilter",
          ref: dateFilter,
          onRefetch: _cache[1] || (_cache[1] = ($event: any) => (emit('update', getFilters()))),
          selected: _ctx.report?.filters.find((f) => f.type === 'daterange')?.value as ReportDateFilter['value']
        }, null, 8, ["selected"]))
      : _createCommentVNode("", true),
    (_ctx.report?.filters.some((f) => f.type === 'unit_value_type'))
      ? (_openBlock(), _createBlock(UnitValueTypeFilter, {
          key: 2,
          ref_key: "unitValueTypeFilters",
          ref: unitValueTypeFilters,
          onRefetch: _cache[2] || (_cache[2] = ($event: any) => (emit('update', getFilters()))),
          selected: _ctx.report?.filters.find((f) => f.type === 'unit_value_type')?.value as ReportUnitValueTypeFilter['value']
        }, null, 8, ["selected"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})